import { render, staticRenderFns } from "./PetRegist.vue?vue&type=template&id=68609b35&"
import script from "./PetRegist.vue?vue&type=script&lang=js&"
export * from "./PetRegist.vue?vue&type=script&lang=js&"
import style0 from "./PetRegist.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports